import { Controller } from "@hotwired/stimulus"
import { GHL_POLL_MS } from "./import_wizard_controller"

// Import Leads → Results updates on its own (#16949 item 5). Sits on the
// Results card inside the `import_results` turbo-frame, and only while the
// server says something is still moving (ResultsPresenter#refresh): the
// import is running, or its paced Workflow enrollment is still adding leads.
//
// It reloads the frame from import_leads#results — the same partial and
// presenter the page rendered, never a second renderer. A reload replaces
// this card, so this controller disconnects and the new card carries the
// next decision: a card rendered after the import settled has no controller,
// and polling stops by itself.
//
// Every GHL_POLL_MS (the Import from GHL popup's poll) while rows import; the
// paced enrollment moves one batch every few minutes, so it polls slowly. The
// Finisher's notice (`goat:realtime-event` carrying this lead_import_id)
// reloads at once.
export const ENROLLMENT_POLL_MS = 30000

export default class extends Controller {
  static values = { url: String, importId: Number, slow: Boolean }

  connect () {
    this.onRealtime = (event) => {
      if (Number(event.detail?.lead_import_id) === this.importIdValue) this.refresh()
    }
    document.addEventListener("goat:realtime-event", this.onRealtime)
    this.schedule()
  }

  disconnect () {
    clearTimeout(this.timer)
    document.removeEventListener("goat:realtime-event", this.onRealtime)
  }

  schedule () {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refresh(), this.slowValue ? ENROLLMENT_POLL_MS : GHL_POLL_MS)
  }

  refresh () {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    // Re-armed in case this load fails and leaves this card in place; a
    // successful load replaces the card and clears the timer in disconnect.
    this.schedule()
    if (frame.getAttribute("src") === this.urlValue) frame.reload()
    else frame.src = this.urlValue
  }
}
